import React from 'react';

import {
  MenuItem,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';

const NestedMenuItem = ({
  title,
  handleClick,
  icon,
  open,
  children,
}: {
  title: string;
  handleClick: () => void;
  icon: ReactJSXElement;
  open?: boolean;
  children?: any[];
}) => {
  return (
    <MenuItem>
      <List component="nav">
        <ListItemButton onClick={handleClick} sx={{ padding: 0 }}>
          <ListItemIcon sx={{ minWidth: '10px' }}>{icon}</ListItemIcon>
          <ListItemText primary={title} />
          {open !== undefined && (open ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List
            component="div"
            sx={{
              padding: 0,
              borderLeft: '0.5px solid lightgrey',
              marginLeft: '10px',
            }}
          >
            {children &&
              children.map(child => (
                <ListItemButton onClick={child.handleClick}>
                  {child.icon && <ListItemIcon>{child.icon}</ListItemIcon>}
                  <ListItemText primary={child.title} />
                </ListItemButton>
              ))}
          </List>
        </Collapse>
      </List>
    </MenuItem>
  );
};

export default NestedMenuItem;
